import { useEffect, useRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { Trans, useTranslation } from 'next-i18next';
import '@/shared/features/classroom/constants/events.quiz-classroom-point';
import { trackEvent } from '@zep/logger/tracking';
import { ChevronRightIcon } from '@/icons';
import { EventModal } from '@/shared/components/EventModal';
/**
 * 무료 젤리 첫 지급 안내 모달 카피.
 */
export const POINT_RELEASE_COPY = {
  title: {
    key: 'common:pointRelease.title'
  },
  description: {
    key: 'common:pointRelease.description'
  },
  primaryButton: {
    key: 'common:pointRelease.primaryButton'
  },
  secondaryButton: {
    key: 'common:pointRelease.secondaryButton'
  }
} as const;

// 젤리(Zelly) 전용 일러스트 — 로케일 텍스트가 없어 단일 이미지로 공용.

interface PointReleaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDismissForToday: () => void;
  onStart: () => void;
  triggeredOn?: string;
}

/**
 * 무료 젤리 첫 지급 안내 모달.
 * 앱 진입 시, 무료 젤리를 아직 쓰지 않은 선생님에게 노출한다.
 * (실제 노출 판정은 usePointReleaseModal 이 담당)
 */
export const PointReleaseModal = ({
  isOpen,
  onClose,
  onDismissForToday,
  onStart,
  triggeredOn
}: PointReleaseModalProps) => {
  const {
    t
  } = useTranslation(['common']);
  const hasTrackedView = useRef(false);
  useEffect(() => {
    if (isOpen && !hasTrackedView.current) {
      trackEvent('quiz_point_release_view', {
        place: triggeredOn ?? ''
      });
      hasTrackedView.current = true;
    }
  }, [isOpen, triggeredOn]);
  const handlePrimaryClick = () => {
    trackEvent('quiz_point_release_start_click', {});
    onStart();
  };
  return <EventModal isOpen={isOpen} onClose={onClose} closeLabel={t('global.close.button')} title={<Trans t={t} i18nKey={POINT_RELEASE_COPY.title.key} components={{
    Highlight: <span className="text-purple-600" />
  }} />} description={t(POINT_RELEASE_COPY.description.key)}
  // 설명 모달(`PointIntroModal`)과 같은 아트다. 파일명의 `-v2` 는 캐시를 끊기
  // 위한 것이니 지우지 말 것 — 자세한 이유는 그쪽 주석에 적어 두었다.
  imageUrl="/assets/point-modal-zelly-v2@2x.webp"
  // 배지·버튼 모두 젤리의 보라다(시안 1890:35971). 파랑–민트로 두면 같은 젤리를
  // 말하는 인트로 모달(`PointIntroModal`)과 다른 기능처럼 보인다.
  badge={{
    label: 'New'
  }} primaryLabel={t(POINT_RELEASE_COPY.primaryButton.key)} primaryIntent="gradient"
  // 「젤리 주기」는 여기서 끝나지 않고 지급 모달로 이어진다 — 라벨 뒤 화살표가 그 이동이다.
  primaryRightIcon={<ChevronRightIcon size="xs" fill={ICON_COLOR.inverse} />} primaryClassName="hover-shine bg-gradient-to-r from-purple-400 to-violet-400 hover:from-purple-400 hover:to-violet-400" onPrimaryClick={handlePrimaryClick} secondaryLabel={t(POINT_RELEASE_COPY.secondaryButton.key)} onSecondaryClick={onDismissForToday} data-sentry-element="EventModal" data-sentry-component="PointReleaseModal" data-sentry-source-file="PointReleaseModal.tsx" />;
};